var React = require('react');

function Claim (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"icon/claim"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("g",{"id":"icon/claim","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","strokeLinecap":"round","strokeLinejoin":"round","key":2},[React.createElement("path",{"d":"M16.6875,2.5 L4.875,2.5 C3.01103897,2.5 1.5,4.06700338 1.5,6 L1.5,34 C1.5,35.9329966 3.01103897,37.5 4.875,37.5 L25.125,37.5 C26.988961,37.5 28.5,35.9329966 28.5,34 L28.5,14.75 L16.6875,2.5 Z","id":"Path","stroke":"#4355F3","strokeWidth":"3","key":0}),React.createElement("polyline",{"id":"Path","stroke":"#4355F3","strokeWidth":"3","points":"15.5 2.5 15.5 15.5 27.5 15.5","key":1})])]);
}

Claim.defaultProps = {"width":"40px","height":"40px","viewBox":"0 0 40 40","version":"1.1"};

module.exports = Claim;

Claim.default = Claim;
